import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiService } from '../services/apiService';

const Reports = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState(null);
  const [recentUsers, setRecentUsers] = useState([]);
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    const loadReports = async () => {
      try {
        setLoading(true);
        setError('');
        const [dashboard, classData] = await Promise.all([
          apiService.get('dashboard'),
          apiService.getAll('classes'),
        ]);

        setStats(dashboard.stats || {});
        setRecentUsers(dashboard.recentUsers || []);
        setClasses(classData || []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load reports.');
      } finally {
        setLoading(false);
      }
    };

    loadReports();
  }, []);

  if (loading) return <LoadingSpinner message="Loading reports..." />;

  return (
    <div className="page-container">
      <div className="page-header"><h1>Reports</h1></div>

      {error && <div className="error-message">{error}</div>}

      <div className="stats-grid" style={{ marginBottom: '2rem' }}>
        {[
          { label: 'Total Learners', value: stats?.students || 0, icon: '🎓' },
          { label: 'Total Staff', value: stats?.teachers || 0, icon: '👨‍🏫' },
          { label: 'Total Classes', value: stats?.classes || 0, icon: '🏫' },
          { label: 'Total Modules', value: stats?.modules || stats?.subjects || 0, icon: '📚' },
        ].map(item => (
          <div key={item.label} className="stat-card">
            <div style={{ fontSize: '1.75rem' }}>{item.icon}</div>
            <h3>{item.label}</h3>
            <div className="stat-value">{item.value}</div>
          </div>
        ))}
      </div>

      <div className="dashboard-section" style={{ marginBottom: '1.5rem' }}>
        <h2>Recent Users</h2>
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Date Added</th>
              </tr>
            </thead>
            <tbody>
              {recentUsers.length === 0 ? (
                <tr><td colSpan={3} className="no-data-message">No recent users found.</td></tr>
              ) : (
                recentUsers.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.role}</td>
                    <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="dashboard-section">
        <h2>Classes Overview</h2>
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>Class</th>
                <th>Teacher</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {classes.length === 0 ? (
                <tr><td colSpan={3} className="no-data-message">No classes found.</td></tr>
              ) : (
                classes.map(item => (
                  <tr key={item._id}>
                    <td>{item.name}</td>
                    <td>{item.teacher?.name || 'Not assigned'}</td>
                    <td>{item.description || 'No description'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Reports;
